export const supportReadPlatforms: General.PlatformUpperCaseTunnel[] = [
  'LAZADA',
  'WA_BIZ',
  'KWAI',
  'FACEBOOK',
];

export const supportRecallPlatforms: General.PlatformUpperCaseTunnel[] = ['LAZADA'];

export const failCauseCode = [
  'error_auth',
  'user_is_unauthorized',
  'IllegalAccessToken',
  '401',
  '_105001_',
  '_105002_',
  '_45101004_',
];
